import {omit, difference, keys, keyBy, createReducer} from 'helpers';

export const index = createReducer({}, {

  LIST_UPDATE: (state, { list, generateId }) => ({
    ...state,
    [list.id || generateId('id')]: {
      id: generateId('id'),
      color: list.color || '#000000',
      ...state[list.id],
      ...list,
    }
  }),

  LIST_DELETE: (state, { id }) => {
    return omit(state, id);
  },

  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.lists);
    if (action.lists.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.lists, 'id'),
      }, removed);
    }
    return state;
  },

  TESTING_DELETE_ALL: () => ({}),

});
